const relief = [
  {
    name: 'Relief Voorbeeld 1',
    description: [
      'Een voorbeeld van een 3D relief, perfect voor wanddecoratie of als uniek kunstobject.',
      'Andere motieven of formaten op aanvraag.'
    ],
    dimensions: 'max: 250x250x250mm',
    images: [
      require('../../images/relief/Relief_1A.png'),
    ],
    stl: '/products/relief/relief-voorbeeld-1.stl',
    contactLink: '/contact?product=Relief%20Voorbeeld%201',
    price: '29,99',
  },
];

export default relief; 